<template>
  <div class="page-effect" style="height: 100%">
    <!-- <div id="websdkready" onclick="websdkready();"></div> -->
    <!-- <div
      @click="generateSignature"
      style="position: absolute; z-index: 9999999"
    >
      Join
    </div> -->
    <div id="ZoomEmbeddedApp" style="height: 100%"></div>
  </div>
</template>
<style>
#zmmtg-root {
  position: relative !important;
}
#zmmtg-root .root-inner {
  position: relative !important;
}
#zmmtg-root .main-content {
  height: 100% !important;
}
#zmmtg-root .meeting-app {
  position: relative !important;
  height: 100% !important;
}
#zmmtg-root .meeting-app > div {
  height: 100% !important;
}
#zmmtg-root .meeting-client {
  position: relative !important;
}
#zmmtg-root .meeting-client-inner {
  position: relative !important;
}
/* #zmmtg-root .chat-virtualized-list {
  height: 440px !important;
} */
#zmmtg-root .Pane.horizontal.Pane2,
#zmmtg-root .main-layout,
#zmmtg-root .multi-view,
#zmmtg-root .multi-view__canvas {
  height: 100% !important;
}

.meeting-info-container.meeting-info-container--right-side {
  /* display: none !important; */
  right: 0 !important;
  top: 0 !important;
}

.full-screen-icon.meeting-info-container__full-screen {
  position: relative !important;
  right: 10px;
  top: 12px;
}
#ZoomEmbeddedApp {
  position: relative !important;
}
#ZoomEmbeddedApp .dropdown.open.btn-group:hover ul {
  display: block !important;
}
#ZoomEmbeddedApp .dropdown-menu {
  right: 0 !important;
  left: auto !important;
  padding: 5px 15px !important;
}
#ZoomEmbeddedApp .full-screen-widget__button.dropdown-toggle.btn-default {
  color: #fff;
  margin-bottom: 0 !important;
}
#ZoomEmbeddedApp .full-screen-widget__pop-menu.dropdown-menu {
  margin-top: 0 !important;
  min-width: 13rem;
  top: 28px;
}
.full-screen-widget__pop-menu > li {
  margin: 5px 0;
}
.full-screen-widget__pop-menu > li > a {
  /* color: #000 !important; */
  padding: 5px 30px 5px 30px;
}
/* .full-screen-widget__pop-menu--checked a::before {
  background: none;
} */
.full-screen-widget__pop-menu.dropdown-menu a::before {
  content: "";
  width: 13px;
  height: 12px;
  position: absolute;
  left: 15px;
  top: 9px;
}
#ZoomEmbeddedApp .chat-container.window-content-bottom {
  height: 100% !important;
}
</style>
<script src="@/js/zoomweb/vconsole.min.js"></script>

<script>
// import db from "../components/firebaseInit";
// import APIs from "@/components/APIInit";
// import router from "../router";
import jQuery from "jquery";
let $ = jQuery;
// import Vue from "vue";

// Vue.http.headers.common['Cross-Origin-Embedder-Policy'] = 'unsafe-none';
// Vue.http.headers.common['Cross-Origin-Opener-Policy'] = 'unsafe-none';

var vm;
export default {
  props: {
    meetingNumber: {
      type: Number,
      default: null,
    },
    role: {
      type: String,
      default: "",
    },
    userName: {
      type: String,
      default: "",
    },
    userEmail: {
      type: String,
      default: "",
    },
    tk: {
      type: String,
      default: "",
    },
    startZoomWebCall: {
      type: Boolean,
      default: false,
    },
    endZoomWebCall: {
      type: Boolean,
      default: false,
    },
    isComponent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      apiKey: "hCamgU8QRI6a3LUm9y31vQ",
      apiSecret: "iY6mvWQld5RZU4dpltW2SW3XkNdopGrIMKCv",
      passWord: "rb1234",
      signature: "",
      leaveUrl: "/zoom-web",

      // tk: "CCJ694andfRgzTKsq7osEjuwYWTgIYExibDZwPeqcE0.DQMAAAAWkSRd1hZ0XzNEUHhFYlJZQ3pYcktudEw5UGdRAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
      // meetingNumber: 96924360150,
      // role: 0,
      // userName: "Debashis",
      // userEmail: "debayanghosh@webspiders.com",
    };
  },
  headers: {
    "Cross-Origin-Embedder-Policy": "unsafe-none",
    "Cross-Origin-Opener-Policy": "unsafe-none",
  },
  computed: {},
  watch: {
    startZoomWebCall(val) {
      if (val) {
        if ($("#ZoomEmbeddedApp") && $("#zmmtg-root")) {
          $("#zmmtg-root").detach().appendTo("#ZoomEmbeddedApp");
        }
        vm.generateSignature();
      }
    },
  },
  created() {
    vm = this;
    //vm.initScreen();
    // $(window).resize(function () {
    //   vm.initScreen();
    // });
  },
  mounted() {
    vm.uid = vm.getSessionUserId();
    vm.clientId = vm.getClientId();
    vm.eventId = vm.getEventId();
    vm.event_collectionName = vm.getEventCollectionName();
    if (!vm.isComponent) {
      vm.meetingNumber = 96924360150;
      vm.userName = "Debashis";
      vm.userEmail = "debayanghosh@webspiders.com";
      vm.role = "0";
      vm.tk =
        "CCJ694andfRgzTKsq7osEjuwYWTgIYExibDZwPeqcE0.DQMAAAAWkSRd1hZ0XzNEUHhFYlJZQ3pYcktudEw5UGdRAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA";

      // vm.meetingNumber = 97726631663;
      // vm.userName = "zoom_dev";
      // vm.userEmail = "zoom_dev@e2m.live";
      // vm.role = "1";
      // vm.tk ="";

      setTimeout(() => {
        vm.startZoomWebCall = true;
      }, 5000);
    }
    //vm.ImportExternalJS();
    // setTimeout(() => {
    //   // var testTool = window.testTool;
    //   // console.log(testTool);
    //   debugger;
    //   //vm.websdkready();
    //   //vm.generateSignature();
    //   //vm.beginJoin();
    // }, 10000);
  },
  methods: {
    ImportExternalJS() {
      let reactMin = document.createElement("script");
      reactMin.setAttribute(
        "src",
        "https://source.zoom.us/2.1.1/lib/vendor/react.min.js"
      );
      reactMin.setAttribute("type", "text/javascript");
      document.body.appendChild(reactMin);

      let reactDomMin = document.createElement("script");
      reactDomMin.setAttribute(
        "src",
        "https://source.zoom.us/2.1.1/lib/vendor/react-dom.min.js"
      );
      reactDomMin.setAttribute("type", "text/javascript");
      document.body.appendChild(reactDomMin);

      let reduxMin = document.createElement("script");
      reduxMin.setAttribute(
        "src",
        "https://source.zoom.us/2.1.1/lib/vendor/redux.min.js"
      );
      reduxMin.setAttribute("type", "text/javascript");
      document.body.appendChild(reduxMin);

      let reduxThunkMin = document.createElement("script");
      reduxThunkMin.setAttribute(
        "src",
        "https://source.zoom.us/2.1.1/lib/vendor/redux-thunk.min.js"
      );
      reduxThunkMin.setAttribute("type", "text/javascript");
      document.body.appendChild(reduxThunkMin);

      let lodashMin = document.createElement("script");
      lodashMin.setAttribute(
        "src",
        "https://source.zoom.us/2.1.1/lib/vendor/lodash.min.js"
      );
      lodashMin.setAttribute("type", "text/javascript");
      document.body.appendChild(lodashMin);

      let zoomMeetingMin = document.createElement("script");
      zoomMeetingMin.setAttribute(
        "src",
        "https://source.zoom.us/zoom-meeting-2.1.1.min.js"
      );
      zoomMeetingMin.setAttribute("type", "text/javascript");
      document.body.appendChild(zoomMeetingMin);

      // < src="js/tool.js"></>
      // < src="js/vconsole.min.js"></>
      // < src="js/index.js"></>

      var baseUrl = location.origin;

      let tool = document.createElement("script");
      tool.setAttribute("src", baseUrl + "/js/zoomweb/tool.js");
      tool.setAttribute("type", "text/javascript");
      document.body.appendChild(tool);

      let vconsoleMin = document.createElement("script");
      vconsoleMin.setAttribute("src", baseUrl + "/js/zoomweb/vconsole.min.js");
      vconsoleMin.setAttribute("type", "text/javascript");
      document.body.appendChild(vconsoleMin);

      let index = document.createElement("script");
      index.setAttribute("src", baseUrl + "/js/zoomweb/index.js");
      index.setAttribute("type", "text/javascript");
      document.body.appendChild(index);

      // setTimeout(() => {
      //   var elmnt = document.getElementById("websdkready");
      //   elmnt.click();
      // }, 5000);
      // debugger;
    },

    // websdkready() {
    //   var testTool = window.testTool;
    //   // get meeting args from url
    //   var tmpArgs = testTool.parseQuery();
    //   var meetingConfig = {
    //     apiKey: tmpArgs.apiKey,
    //     meetingNumber: tmpArgs.mn,
    //     userName: (function () {
    //       if (tmpArgs.name) {
    //         try {
    //           return testTool.b64DecodeUnicode(tmpArgs.name);
    //         } catch (e) {
    //           return tmpArgs.name;
    //         }
    //       }
    //       return (
    //         "CDN#" +
    //         tmpArgs.version +
    //         "#" +
    //         testTool.detectOS() +
    //         "#" +
    //         testTool.getBrowserInfo()
    //       );
    //     })(),
    //     passWord: tmpArgs.passWord,
    //     leaveUrl: "/index.html",
    //     //leaveUrl: "https://ws.e2m.live",
    //     role: parseInt(tmpArgs.role, 10),
    //     userEmail: (function () {
    //       try {
    //         return testTool.b64DecodeUnicode(tmpArgs.email);
    //       } catch (e) {
    //         return tmpArgs.email;
    //       }
    //     })(),
    //     lang: tmpArgs.lang,
    //     signature: tmpArgs.signature || "",
    //     china: tmpArgs.china === "1",
    //     tk: tmpArgs["tk"] ? tmpArgs["tk"] : "",
    //   };

    //   // a tool use debug mobile device
    //   if (testTool.isMobileDevice()) {
    //     vConsole = new VConsole();
    //   }
    //   console.log(JSON.stringify(ZoomMtg.checkSystemRequirements()));

    //   // it's option if you want to change the WebSDK dependency link resources. setZoomJSLib must be run at first
    //   // ZoomMtg.setZoomJSLib("https://source.zoom.us/2.1.1/lib", "/av"); // CDN version defaul
    //   if (meetingConfig.china)
    //     ZoomMtg.setZoomJSLib("https://jssdk.zoomus.cn/2.1.1/lib", "/av"); // china cdn option
    //   ZoomMtg.preLoadWasm();
    //   ZoomMtg.prepareJssdk();
    // },
    beginJoin() {
      debugger;
      ZoomMtg.preLoadWasm();
      ZoomMtg.prepareJssdk();
      //var rootElement = document.getElementById("ZoomEmbeddedApp");
      var rootElement = document.getElementById("zmmtg-root");
      rootElement.style.display = "block";
      rootElement.style.setProperty("display", "block", "important");
      //zoomAppRoot: rootElement,
      //viewLayout: 'gallery',
      debugger;
      vm.leaveUrl = location.pathname;
      ZoomMtg.init({
        disablePreview: true,
        leaveUrl: vm.leaveUrl, //"/zoom-web", //"https://ws.e2m.live", //meetingConfig.leaveUrl,
        webEndpoint: undefined, //"zoom.us", //meetingConfig.webEndpoint,
        disableCORP: false, //!window.crossOriginIsolated, // default true
        // disablePreview: false, // default false
        success: function () {
          debugger;
          //alert(meetingConfig.tk)
          //console.log(meetingConfig);
          //console.log("signature", signature);
          // ZoomMtg.i18n.load(meetingConfig.lang);
          // ZoomMtg.i18n.reload(meetingConfig.lang);
          ZoomMtg.i18n.load("en-US");
          ZoomMtg.i18n.reload("en-US");
          if (vm.tk) {
            debugger;
            ZoomMtg.join({
              meetingNumber: vm.meetingNumber,
              userName: vm.userName,
              signature: vm.signature,
              apiKey: vm.apiKey,
              userEmail: vm.userEmail,
              passWord: vm.passWord,
              tk: vm.tk,
              success: function (res) {
                debugger;
                console.log("join meeting success");
                console.log("get attendeelist");
                ZoomMtg.getAttendeeslist({});
                ZoomMtg.getCurrentUser({
                  success: function (res) {
                    if (
                      $("#ZoomEmbeddedApp") &&
                      $(
                        ".meeting-info-container.meeting-info-container--right-side"
                      )
                    ) {
                      $(
                        ".meeting-info-container.meeting-info-container--right-side"
                      )
                        .detach()
                        .appendTo("#ZoomEmbeddedApp");
                    }
                    //ZoomMtg.viewLayout('gallery');
                    console.log(
                      "success getCurrentUser",
                      res.result.currentUser
                    );
                  },
                });
              },
              error: function (res) {
                debugger;
                console.log(res);
              },
            });
          } else {
            debugger;
            ZoomMtg.join({
              meetingNumber: vm.meetingNumber,
              userName: vm.userName,
              signature: vm.signature,
              apiKey: vm.apiKey,
              userEmail: vm.userEmail,
              passWord: vm.passWord,
              success: function (res) {
                debugger;
                console.log("join meeting success");
                console.log("get attendeelist");
                ZoomMtg.getAttendeeslist({});
                ZoomMtg.getCurrentUser({
                  success: function (res) {
                    console.log(
                      "success getCurrentUser",
                      res.result.currentUser
                    );
                  },
                });
              },
              error: function (res) {
                debugger;
                console.log(res);
              },
            });
          }
        },
        error: function (res) {
          debugger;
          console.log(res);
        },
      });

      ZoomMtg.inMeetingServiceListener("onUserJoin", function (data) {
        debugger;
        console.log("inMeetingServiceListener onUserJoin", data);
      });

      ZoomMtg.inMeetingServiceListener("onUserLeave", function (data) {
        //alert("");
        debugger;
        console.log("inMeetingServiceListener onUserLeave", data);
      });

      ZoomMtg.inMeetingServiceListener(
        "onUserIsInWaitingRoom",
        function (data) {
          debugger;
          console.log("inMeetingServiceListener onUserIsInWaitingRoom", data);
        }
      );

      ZoomMtg.inMeetingServiceListener("onMeetingStatus", function (data) {
        debugger;
        console.log("inMeetingServiceListener onMeetingStatus", data);
      });
    },
    generateSignature() {
      debugger;
      ZoomMtg.preLoadWasm();
      ZoomMtg.prepareJssdk();
      ZoomMtg.generateSignature({
        meetingNumber: vm.meetingNumber,
        apiKey: vm.apiKey,
        apiSecret: vm.apiSecret,
        role: vm.role,
        success: function (res) {
          debugger;
          vm.signature = res.result;

          vm.beginJoin();
          // console.log(res.result);
          // meetingConfig.signature = res.result;
          // meetingConfig.apiKey = API_KEY;
          // var joinUrl = "/meeting.html?" + testTool.serialize(meetingConfig);
          // console.log(joinUrl);
          // location.href = joinUrl;
          // //window.open(joinUrl, "_blank");
        },
      });
    },
  },
};
</script>